"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef } from "react";
import { ActionIcon, CrossIcon, SearchIcon } from "../../icons/index.js";
import makeStyles from "../../theming/make-styles.js";
import useCombinedRefs from "../utils/use-combined-refs.js";
import Input from "./input.js";
const useStyles = makeStyles()({
    input: {
        "& ::-webkit-search-cancel-button": {
            display: "none",
        },
    },
});
export const SearchInput = React.forwardRef(function SearchInput(_a, ref) {
    var { className, value, onChange } = _a, props = __rest(_a, ["className", "value", "onChange"]);
    const { classes, cx } = useStyles();
    const innerRef = useRef(ref);
    const combinedRef = useCombinedRefs(ref, innerRef);
    function handleAction() {
        var _a;
        onChange === null || onChange === void 0 ? void 0 : onChange("", { target: innerRef.current });
        (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
    const icon = (props) => (_jsx(ActionIcon, Object.assign({ active: !!value, icon: !!value ? CrossIcon : props => _jsx("svg", Object.assign({}, props)), onAction: handleAction }, props)));
    return (_jsx(Input, Object.assign({ ref: combinedRef, className: cx(classes.input, className), leftIcon: SearchIcon, rightIcon: icon, type: "search", value: value, onChange: onChange }, props)));
});
export default SearchInput;
//# sourceMappingURL=search-input.js.map